import store from 'store';
import ModuleConfig from '../Module.json';
import Helper from './Helper.js';

const keyMerchant = 'merchant';

class Storage {
  static cookLocalStorageKey(key) {
    return key ? `${ModuleConfig.id}_${key}` : null;
  }

  static setLocalMerchant(merchant, exp) {
    const merchants = this.getLocalStorage(keyMerchant);
    const formatedKey = this.cookLocalStorageKey(keyMerchant);
    if (merchants && merchants.length && !merchants.some(m => m.id === merchant.id)) {
      store.set(formatedKey, {
        value: [...merchants, merchant],
        exp: exp || null,
        time: new Date().getTime(),
      });

      return store.get(keyMerchant);
    }
    store.set(formatedKey, {
      value: [merchant],
      exp: exp || null,
      time: new Date().getTime(),
    });
    return store.get(formatedKey);
  }

  static getLocalStorageMerchant(merchantId = Helper.getCurrentMerchantId()) {
    const merchantList = Storage.getLocalStorage(keyMerchant);

    if (merchantList && merchantList.length) {
      return merchantList.find(merchant => merchant.id === Number(merchantId)) || {};
    }
    return null;
  }

  static setLocalStorage(key, value, exp) {
    if (key === keyMerchant) {
      return this.setLocalMerchant(value, exp);
    }

    if (key && value) {
      const formatedKey = this.cookLocalStorageKey(key);
      store.set(formatedKey, {
        value,
        exp: exp || null,
        time: new Date().getTime(),
      });
      return store.get(formatedKey);
    }
    return null;
  }

  static getLocalStorage(key) {
    const info = store.get(this.cookLocalStorageKey(key));

    if (!info || typeof info === 'undefined') return null;
    if (info.exp && new Date().getTime() - info.time > info.exp) return null;

    return info.value;
  }

  static removeLocalStorage(key) {
    const formatedKey = this.cookLocalStorageKey(key);
    const info = store.get(formatedKey);

    if (!info || typeof info === 'undefined') return null;

    store.set(formatedKey, {
      value: null,
      exp: null,
      time: new Date().getTime(),
    });
    return true;
  }
}

export default Storage;



// WEBPACK FOOTER //
// ./src/helpers/storage.js